require('../bootstrap');

import env from '../config/env';
import router from  '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;

const store = {
    state: {
        user: {
            name: '',
            picture: '',
            job: '',
            email: '',
            id: 0
        },
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        breadcrumbs: [{ name: "Home", route: "/" }],
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        },
        url: state => {
            return state.url;
        },

    },
    mutations: {
        auth(state, token) {
            //Caso seja um login do rediorecionamento
            let hashed_token = new URL(location.href).searchParams.get('hashed_token')
            if(hashed_token && !token){
                const self = this;
                const api = state.api + "getAccessToken";
            
                axios
                  .post(api, {
                    token: hashed_token,
                  })
                  .then((response) => {
                    token = response.data

                    if (token != null && token != undefined) {
                        state.authenticated = true;
                        state.token = token;
        
                        localStorage.clear();
                        localStorage.setItem('token', token);
        
                        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                        self.commit('profileUpdate');
                        router.push('/');
                    }

                  })
                  .catch((error) => {
                    self.$message("Erro", error.response, "error");
                  });    
            } else {
                //login normal
                if (token != null && token != undefined) {
                    state.authenticated = true;
                    state.token = token;
    
                    localStorage.clear();
                    localStorage.setItem('token', token);
    
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                    this.commit('profileUpdate');
                }
            }

        },
        profileUpdate(state) {
            let $meRoute = 'me'
            const domainDev = env.domainDev ? env.domainDev : false;
            //const domainDev = true;
            //se for dominio principal
            if(state.api == 'https://api.dds-digital.innovareti.com.br/api/v1/' || state.api == 'https://api.dds-digital-hml.innovareti.com.br/api/v1/' || domainDev == true){
                $meRoute = 'adminMe'
            } 
            
            axios.post(state.api + $meRoute, {
                token: state.token
            })
            .then(response => {
                state.user.id = response.data.id;
                state.user.name = response.data.name;
                state.user.email = response.data.email;
                state.user.picture = response.data.photo;
            })
            .catch(error => {
                localStorage.clear();
                router.push('/login');
            });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        }
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');

            context.commit('auth', token);
        }
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js